<div class="main-container">
  <div class="title">
    <h1 class="wellcome-text">{{ 'Availability_Uptime' | translate }}</h1>
  </div>

  <div class="container">
    <div class="cards-container">
      <div class="card" id="uptime">
        <div class="info card-title">{{ 'UPTIME' | translate }}</div>
        <div class="info card-main-info">
          <span class="card-ico card-uptime-ico card-content-margin-top"></span>
          <span class="card-number card-content-margin-top">{{ availabilityDeviceModel.uptime }}%</span>
          <span class="divider"></span>
        </div>
        <span class="card-sub-title">{{ "LastMonth" | translate }}</span>
      </div>
      <div class="card" id="map">

        <div id="myMap"></div>

        <!-- <div class="info Acard-title">{{ 'UPTIME' | translate }}</div>
        <div class="info card-main-info">
          <span class="card-ico card-total-ico"></span>
          <span class="card-number">98%</span>
          <span class="divider"></span>
        </div> -->
      </div>
      <div class="card" id="info">
        <!-- {{ 'UPTIME' | translate }} -->
        <div class="info card-title">{{ "DEVICE" | translate }}</div>
        <div class="card-detail">
          <div class="card-detail--row">
            <span class="card-detail-cell">{{ "name" | translate }}</span>
            <span class="card-detail-cell">{{ device.Name }}</span>
          </div>
          <div class="card-detail--row">
            <span class="card-detail-cell">{{ "Type" | translate }}</span>
            <span class="card-detail-cell">{{ device.Type }}</span>
          </div>
          <div class="card-detail--row">
            <span class="card-detail-cell">{{ "Location"| translate}}</span>
            <span class="card-detail-cell">{{ device.Location }}</span>
          </div>
          <div class="card-detail--row">
            <span class="card-detail-cell">{{ "Site" | translate }}</span>
            <span class="card-detail-cell">{{ device.Site }}</span>
          </div>
          <div class="card-detail--row">
            <span class="card-detail-cell">{{ "LastConnection" | translate }}</span>
            <span class="card-detail-cell">{{ device.LastConnection| date:'yyyy-MM-dd HH:mm' }}</span>
          </div>
          <div class="card-detail--row">
            <span class="card-detail-cell">{{ "LastEvent" | translate }}</span>
            <span class="card-detail-cell">{{ device.LastEvent | date:'yyyy-MM-dd HH:mm' }}</span>
          </div>
          <div class="card-detail--row">
            <span class="card-detail-cell">{{ "ConnectionStatus" | translate }}</span>
            <span class="card-detail-cell">{{ device.ConnectionStatus }}</span>
          </div>
          <div class="card-detail--row">
            <span class="card-detail-cell"> {{ "Summary" | translate }}</span>
            <div class="card-detail-cell cell-icon-container">
              <span class="icon-summary icon-sumary-{{ this.device.summary.toString().toLowerCase() }}"></span>
              <span>{{ device.summary }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-2x" id="chart">
        <div class="card-controls" [formGroup]="chartFilters">
          <mat-form-field id="chart-type">
            <mat-label>{{ "CHART" | translate }}</mat-label>
            <select matNativeControl required formControlName="chartType">
              <option *ngFor="let option of chartOptions" value="{{ option.Value }}">{{ option.Value | translate  }}</option>
              <!-- <option value="saab">Free Disk</option> -->
            </select>
          </mat-form-field>
          <mat-form-field class="example-form-field">
            <mat-label>{{ "DATE_RANGE" | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="campaignTwoPicker" [min]="minDate" [max]="maxDate">
              <input matStartDate placeholder="Start date" formControlName="start" >
              <input matEndDate placeholder="End date" formControlName="end" >
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="campaignTwoPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #campaignTwoPicker></mat-date-range-picker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ "QUERY_TYPE" | translate }}</mat-label>
            <select matNativeControl required formControlName="queryType">
              <option *ngFor="let option of queryType" value="{{ option.Value }}">{{ option.Value | translate }}</option>
              <!-- <option value="saab">Free Disk</option> -->
            </select>
          </mat-form-field>
          <button class="chart-button" mat-raised-button (click)="search()">
            {{ "SEARCH" | translate }}
          </button>
        </div>

        <button class="card-icon-button" mat-icon-button (click)="openCardControlsMiniEvent()">
          <mat-icon>more_vert</mat-icon>
        </button>


        <div class="card-controls-mini"  [formGroup]="chartFilters" *ngIf="openCardControlsMini == true">
          <mat-form-field>
            <mat-label>{{ "CHART" | translate }}</mat-label>
            <select matNativeControl required formControlName="chartType">
              <option *ngFor="let option of chartOptions" value="{{ option.Value }}">{{ option.Value | translate  }}</option>
              <!-- <option value="saab">Free Disk</option> -->
            </select>
          </mat-form-field>
          <mat-form-field class="example-form-field">
            <mat-label>{{ "DATE_RANGE" | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="campaignTwoPicker">
              <input matStartDate placeholder="Start date" formControlName="start">
              <input matEndDate placeholder="End date" formControlName="end">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="campaignTwoPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #campaignTwoPicker></mat-date-range-picker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ "QUERY_TYPE" | translate }}</mat-label>
            <select matNativeControl required formControlName="queryType">
              <option *ngFor="let option of queryType" value="{{ option.Value }}">{{ option.Value | translate }}</option>
              <!-- <option value="saab">Free Disk</option> -->
            </select>
          </mat-form-field>
          <button class="chart-button" mat-raised-button (click)="search()">
            {{ "SEARCH" | translate }}
          </button>
        </div>

        <div class="chart-container">
          <canvas class="chart-canvas" id="conectivityChart"></canvas>
        </div>
      </div>
    </div>
  </div>
  <div class="card-control-backdrop" *ngIf="openCardControlsMini == true" (click)="closeCardControlsMiniEvent()">
  </div>
</div>